(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ele-birthday-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = Date.parse('2026-09-17T00:01:00+02:00');
  const end = Date.parse('2026-09-20T23:59:00+02:00');
  const clocks = new Set();
  let timer;
  let wasActive = document.documentElement.dataset.eleBirthday === 'active';
  const getRemaining = now => {
    const seconds = Math.max(0, Math.ceil((end - now) / 1000));
    return [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
  };
  const update = () => {
    const now = Date.now();
    const active = now >= start && now < end;
    document.documentElement.dataset.eleBirthday = active ? 'active' : 'inactive';
    if (!active && wasActive && now >= end) {
      const template = document.getElementById('ele-birthday-expired-template');
      if (template && !document.querySelector('.ele-birthday-expired')) {
        document.querySelector('main')?.prepend(template.content.cloneNode(true));
      }
    }
    wasActive = active;
    if (!active) { clearInterval(timer); timer = undefined; return; }
    const remaining = getRemaining(now);
    clocks.forEach(clock => clock.update(remaining));
  };
  const startClock = () => {
    update();
    if (!timer && Date.now() < end) timer = setInterval(update, 1000);
  };
  class EleBirthdayCountdown extends HTMLElement {
    connectedCallback() {
      this.digits = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-ele-${unit}]`));
      this.form = document.getElementById(this.dataset.form || '');
      this.variantChanged = event => {
        const variant = event.detail?.variant;
        this.hidden = !variant?.available || !(variant.compare_at_price > variant.price);
      };
      this.form?.addEventListener('variant:change', this.variantChanged);
      clocks.add(this);
      startClock();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.variantChanged);
      clocks.delete(this);
    }
    update(remaining) {
      this.digits.forEach((digit, index) => {
        if (!digit) return;
        const text = String(remaining[index]).padStart(2, '0');
        if (digit.textContent !== text) digit.textContent = text;
      });
      this.querySelector('.ele-birthday-clock')?.removeAttribute('hidden');
    }
  }
  if (!customElements.get('ele-birthday-countdown')) customElements.define('ele-birthday-countdown', EleBirthdayCountdown);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) startClock(); });
  window.addEventListener('pageshow', startClock);
  startClock();
})();
  } catch(e) { console.error(e); }
})();

})();
